<template>
  <div :class="classes" @click="$emit('click', $event)">
    <slot name="default"></slot>
  </div>
</template>

<script>

export default {
  props: {
    dock: {
      type: String
    }
  },
  computed: {
    classes () {
      let classes = [
        'web-dock-layout'
      ]

      return classes.join(' ')
    }
  },
  methods: {
    build () {
      let space = {top: 0, right: 0, bottom: 0, left: 0}

      this.$children.sort((a, b) => {
        if (a.$attrs.dock && b.$attrs.dock) return 0

        return a.$attrs.dock ? -1 : 1
      })

      this.$children.forEach(child => {
        let style = child.$el.style

        if (child.$attrs.dock) {
          switch (child.$attrs.dock) {
            case 'top':
              style.top = space.top + 'px'
              style.left = space.left + 'px'
              style.right = space.right + 'px'

              space.top = space.top + child.$el.offsetHeight

              break

            case 'bottom':
              style.top = 'auto'
              style.bottom = space.bottom + 'px'
              style.left = space.left + 'px'
              style.right = space.right + 'px'

              space.bottom = space.bottom + child.$el.offsetHeight

              break

            case 'left':
              style.top = space.top + 'px'
              style.bottom = space.bottom + 'px'
              style.left = space.left + 'px'
              style.right = 'auto'

              space.left = space.left + child.$el.offsetWidth

              break

            case 'right':
              style.top = space.top + 'px'
              style.bottom = space.bottom + 'px'
              style.left = 'auto'
              style.right = space.right + 'px'

              space.right = space.right + child.$el.offsetWidth
              
              break
          }
        } else {
          style.top = space.top + 'px'
          style.bottom = space.bottom + 'px'
          style.left = space.left + 'px'
          style.right = space.right + 'px'
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.build()
    })
  }
}

</script>

<style lang="scss" scoped>

html {
  .web-dock-layout > * {
    position: fixed;
    z-index: 2;
  }
}

</style>